// Map API endpoints here

export default $axios => ({
  get(partner, poll, deal) {
    const url = `/api/partnerUser/${partner}/poll/${poll}?dealId=${deal}`;

    return $axios.get(url);
  },
  results(partner, poll, deal) {
    const url = `/api/partnerUser/${partner}/poll/${poll}/results?dealId=${deal}`;

    return $axios.get(url);
  },
  vote(partner, poll, deal, votes) {
    const url = `/api/partnerUser/${partner}/poll/${poll}/vote?dealId=${deal}`;

    return $axios.post(url, { votes });
  }
});
